"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ConfirmDialog = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireWildcard(require("react"));

var _Button = _interopRequireDefault(require("../Button"));

var _Dialog = _interopRequireDefault(require("../Dialog"));

var ConfirmDialog = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(ConfirmDialog, _PureComponent);

  var _super = (0, _createSuper2["default"])(ConfirmDialog);

  function ConfirmDialog() {
    (0, _classCallCheck2["default"])(this, ConfirmDialog);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(ConfirmDialog, [{
    key: "render",
    value: function render() {
      var timeString = new Date().getTime().toString();
      var _this$props = this.props,
          id = _this$props.id,
          title = _this$props.title,
          description = _this$props.description,
          cancelText = _this$props.cancelText,
          confirmText = _this$props.confirmText,
          onClose = _this$props.onClose,
          onConfirm = _this$props.onConfirm,
          confirmButtonProps = _this$props.confirmButtonProps,
          isOpen = _this$props.isOpen,
          alignment = _this$props.alignment,
          maxWidth = _this$props.maxWidth;
      return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
        isOpen: isOpen,
        onClose: onClose,
        maxWidth: maxWidth,
        title: title,
        description: description,
        alignment: alignment,
        actions: [/*#__PURE__*/_react["default"].createElement(_Button["default"], {
          key: "confirm-dialog-cancel-button-".concat(timeString.substr(-4)),
          id: "".concat(id, "-cancel-button"),
          licorice: true,
          ghost: true,
          onClick: onClose
        }, cancelText), /*#__PURE__*/_react["default"].createElement(_Button["default"], Object.assign({
          key: "confirm-dialog-confirm-button-".concat(timeString.substr(-3))
        }, confirmButtonProps, {
          id: "".concat(id, "-confirm-button"),
          onClick: onConfirm
        }), confirmText)]
      });
    }
  }]);
  return ConfirmDialog;
}(_react.PureComponent);

exports.ConfirmDialog = ConfirmDialog;
ConfirmDialog.defaultProps = {
  confirmButtonProps: {},
  alignment: 'center',
  maxWidth: 'xs'
};
var _default = ConfirmDialog;
exports["default"] = _default;